import type { IconNode } from '../types';

/**
 * @name faucet
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuMjIgNC45IDUuNCA2SDVhMiAyIDAgMCAxIDAtNGguNGw0Ljg2IDEiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSI0IiByPSIyIiAvPgogIDxwYXRoIGQ9Im0xMy43OCA0LjkgNC44IDFoLjRhMiAyIDAgMCAwIDAtNGgtLjRsLTQuOTIgMSIgLz4KICA8cGF0aCBkPSJNMTIgNnYzIiAvPgogIDxyZWN0IHdpZHRoPSI0IiBoZWlnaHQ9IjYiIHg9IjE4IiB5PSIxMCIgLz4KICA8cGF0aCBkPSJNMjIgOXY4IiAvPgogIDxwYXRoIGQ9Ik0xOCAxMWgtMi42YTMuODcgMy44NyAwIDAgMC02LjggMEg3Yy0yLjggMC01IDIuMi01IDV2MWg0di0xYzAtLjYuNC0xIDEtMWgxLjZhMy44NyAzLjg3IDAgMCAwIDYuOCAwSDE4IiAvPgogIDxwYXRoIGQ9Ik0zLjUgMTdTMiAxOSAyIDIwYTIgMiAwIDAgMCA0IDBjMC0xLTEuNS0zLTEuNS0zIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/faucet
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const faucet: IconNode = [
  ['path', { d: 'M10.22 4.9 5.4 6H5a2 2 0 0 1 0-4h.4l4.86 1', key: 'wm9nkt' }],
  ['circle', { cx: '12', cy: '4', r: '2', key: 'muu5ef' }],
  ['path', { d: 'm13.78 4.9 4.8 1h.4a2 2 0 0 0 0-4h-.4l-4.92 1', key: '1m244l' }],
  ['path', { d: 'M12 6v3', key: '1m4b9j' }],
  ['rect', { width: '4', height: '6', x: '18', y: '10', key: '126bwb' }],
  ['path', { d: 'M22 9v8', key: '1mrhlp' }],
  [
    'path',
    {
      d: 'M18 11h-2.6a3.87 3.87 0 0 0-6.8 0H7c-2.8 0-5 2.2-5 5v1h4v-1c0-.6.4-1 1-1h1.6a3.87 3.87 0 0 0 6.8 0H18',
      key: '1s1aoo',
    },
  ],
  ['path', { d: 'M3.5 17S2 19 2 20a2 2 0 0 0 4 0c0-1-1.5-3-1.5-3', key: '1cx8wt' }],
];

export default faucet;
